import { Accordion } from '@cimpress/react-components';
import React, { PureComponent } from 'react';
import MapPoints from '../../documents/transforms/mapPoints';
import ColorProfile from './colorProfile';
import { DocumentEffect } from 'src/config/effects';
import EffectsView from './effects';

interface Props {
    id: string;
    effect?: DocumentEffect;
    changeProfileColor: (data: { id: string; colorProfile: string }) => void;
    colorProfile?: string;
    setEffect: (data: { id: string; effectType: string }) => void;
    updateEffectProperty: (data: { id: string; property: string; value: any }) => void;
}

interface State {
    isOpen: boolean;
}

export default class AdvancedView extends PureComponent<Props, State> {
    state: State = {
        isOpen: false,
    };

    handleClick = (_: any, isOpen: boolean) => {
        this.setState({ isOpen });
    };

    render() {
        const { id, effect, changeProfileColor, colorProfile, setEffect, updateEffectProperty } = this.props;

        return (
            <div className='advanced__tools'>
                <Accordion
                    variant='minimal'
                    title={this.state.isOpen ? 'Hide Advanced' : 'Show Advanced'}
                    className='advanced__tools__content'
                    onHeaderClick={this.handleClick}>
                    <h3>Color Properties</h3>
                    <ColorProfile
                        activeProfile={colorProfile}
                        onSelect={(e) => changeProfileColor({ id, colorProfile: e.value })}
                    />
                    <h3>Position</h3>
                    <MapPoints id={id} />
                    <h3>Effects</h3>
                    <EffectsView
                        id={id}
                        effect={effect}
                        setEffect={setEffect}
                        updateEffectProperty={updateEffectProperty}
                    />
                </Accordion>
            </div>
        );
    }
}
